module.exports = __webpack_public_path__ + "static/Spie-1ed40e3e7deabf00c796ce253c2a18b9.png";